export default import.meta.ROLLDOWN_FILE_URL_7uHPdysLKtuyAgSzAal7Ig